module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/The-Midnight-Miracle_Shack-1.b4b0f79.jpg";